import PrivacyPolicy from '@/components/pages/livemallclub/About/PrivacyPolicy'
import { GetServerSideProps, NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const PrivacyPolicyPage: NextPage = () => {
  return <PrivacyPolicy />
}

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: { ...(await serverSideTranslations(locale as string, ['common'])) },
  }
}

export default PrivacyPolicyPage
